import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type LogoImages = {
  logoMiniLight: string
  logoLargeLight: string
  logoMiniDark: string
  logoLargeDark: string
}

export type LogoState = {
  logoShow: boolean
  images: LogoImages | null
  loading: boolean
}

const initialState: LogoState = {
  logoShow: false,
  images: null,
  loading: true,
}

const logoSlice = createSlice({
  name: 'logo',
  initialState,
  reducers: {
    setLogoData: (
      state,
      action: PayloadAction<{ logoShow: boolean; images: LogoImages }>,
    ) => {
      state.logoShow = action.payload.logoShow
      state.images = action.payload.images
      state.loading = false
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setLogoShow: (state, action: PayloadAction<boolean>) => {
      state.logoShow = action.payload
    },
  },
})

export const { setLogoData, setLoading, setLogoShow } = logoSlice.actions
export default logoSlice.reducer
